import { useLayoutEffect } from 'preact/hooks';

import { usePlayer } from './PlayerProvider';

export function usePlayerEvent(
  eventName: string,
  listener: (...args: any[]) => void
): void {
  const player = usePlayer();

  useLayoutEffect(() => {
    if (!listener) {
      return;
    }

    player.on(eventName, listener);

    return () => {
      player.off(eventName, listener);
    };
  }, [player, eventName, listener]);
}
